import styled from "@emotion/styled";
import { default as FilledCircledMinusRaw } from "/public/assets/filled-circled-minus.svg?react";

export const FilledCircledMinus = styled(FilledCircledMinusRaw)`
  color: var(--tw-amber-500);
`;
